module.exports = __webpack_public_path__ + "9600def2dd6eebfccd8a7805db386262.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/scene-snapper-s.png
// module id = 2602
// module chunks = 0